<template lang="pug">
div.container-fluid.px-0
  div.row.mx-0
    ticker
  div.row.mx-0
    template(v-for="(so, sx) in customer.specialOffersList")
      div.menu-banner.col-xs-12.col-sm-12.col-md-12.col-lg-12.offset-lg-12.mt-3(@click="newOrder")
        div
          img(v-if="typeof so.menuImage != 'undefined' && so.menuImage.mimeType != 'video/mp4'" :src=" 'data:' + so.menuImage.mimeType + ';base64,'+ so.menuImage.data")
          video(v-if="typeof so.menuImage != 'undefined' && so.menuImage.mimeType == 'video/mp4'" autoplay style="width:100%" muted onloadeddata="this.play();" :loop="so.menuImage.name.includes('loop')")
              source(type="video/mp4" :src=" 'data:' + so.menuImage.mimeType + ';base64,'+ so.menuImage.data")
          p {{ so.description }}
    // Customer area banner slider (2 tiles width)
    div.col-xs-12.col-sm-12.col-md-12.col-lg-8.offset-lg-2.my-3
      banner-slider(
        location="menu"
        alt="Customer Area Banner"
        container-class="customer-banner"
        @banner-click="handleBannerClick"
      )

    div.col-xs-12.col-sm-6.col-md-6.col-lg-4.offset-lg-2.my-3
      div.card(
        @click="showOrderHistory"
        )
        div.card-header
          | Meine Bestellungen
        div.card-body.background-orders
    div.col-xs-12.col-sm-6.col-md-6.col-lg-4.my-3
      div.card(
        @click="newOrder"
        )
        div.card-header
          | Neue Bestellung
        div.card-body.background-new
    // Hide Download-Bereich and Händler News for students
    template(v-if="!isStudent")
      div.col-xs-12.col-sm-6.col-md-6.col-lg-4.offset-lg-2.my-3
        div.card(
          @click="showDownloadArea"
          )
          div.card-header
            | Download-Bereich
          div.card-body.background-download
      div.col-xs-12.col-sm-6.col-md-6.col-lg-4.my-3
        div.card(
          @click="showCustomerNews"
          )
          div.card-header
            | Händler News
          div.card-body.background-news
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ticker from '@/components/ticker'
import BannerSlider from '@/components/common/BannerSlider'

export default {
  name: 'Menu',
  components: {
    ticker,
    BannerSlider
  },
  computed: {
    ...mapGetters('authentication', [
      'customer'
    ]),
    isStudent () {
      return this.customer && this.customer.studentProducts === 1
    }
  },
  methods: {
    ...mapActions('ui', [
      'newOrder',
      'showCustomerNews',
      'showDownloadArea',
      'showOrderHistory'
    ]),
    handleBannerClick (clickData) {
      // Navigate to order form and focus on specific product
      this.$router.push({
        name: 'new-order',
        params: {
          focusModelNumber: clickData.modelNumber
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .menu-banner > div
    border 1px solid rgba(0,0,0,.125)
    border-radius 0.25rem
    overflow hidden
    cursor pointer
    margin: 0 auto;
    max-width: 66%;

  .menu-banner > div > p
    font-size 115%
    margin-bottom 0
    padding 0.25rem 1.25rem
  .menu-banner img
    max-width 100%
  .card
    cursor pointer
    min-height 300px

    .card-text
      width 75%
      position absolute
      bottom 20px
      right 20px
      background rgba(255, 255, 255, 0.75)
      font-size 125%
      padding 12px

  .background-new
    background url('../assets/images/new.jpg')
    background-size cover

  .background-orders
    background url('../assets/images/orders.jpg')
    background-size cover

  .background-download
    background url('../assets/images/download.jpg')
    background-size cover

  .background-news
    background url('../assets/images/news.jpg')
    background-size cover

  .customer-banner
    border-radius: 8px
    overflow: hidden
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15)
    transition: transform 0.3s ease, box-shadow 0.3s ease

    &:hover
      transform: translateY(-2px)
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2)

  @media (max-width: 1000px)
    .menu-banner > div
      max-width: 100%;
</style>
